import axios from 'axios';
import authHeader from "@/api/auth-header";

const API_URL = process.env.VUE_APP_BASE_API + 'auth/'

class AuthService {
    login(user) {
        return axios
            .post(API_URL + 'login', {
                // username: user.username,
                email: user.email,
                password: user.password
            })
            .then(response => {
                this.setLocalStorage(response)
                return response.data;
            });
    }

    setLocalStorage(response) {
        if (response.data.access_token) {
            response.data.accessToken = response.data.access_token;
            localStorage.setItem('user', JSON.stringify(response.data));
            window.Laravel = {
                csrfToken: response.data.csrf,
                jsPermissions: response.data.permissions
            }
        }
    }

    setUserDataLocalStorage(response) {
        if (response.data.data) {
            localStorage.setItem('userdata', JSON.stringify(response.data.data));
        }
    }

    logout() {
        localStorage.removeItem('user');
        return axios.get(API_URL + 'logout', { headers: authHeader() });

    }

    register(user) {
        return axios.post(API_URL + 'signup', {
            // username: user.username,
            name: user.name,
            email: user.email,
            password: user.password,
            confirm_password: user.confirm_password
        });
    }
    me(user) {
        return axios
            .get(API_URL + 'user', { headers: authHeader() })
            .then(response => {
                if (response.data) {
                    this.setUserDataLocalStorage(response)
                }
                return response.data;
            });
    }
}

export default new AuthService();
